import React, {useEffect, useState} from 'react'
import { useForm, Controller } from "react-hook-form";
import FormGroup from 'components/Form/FormGroup'
import FormImage from 'components/Form/FormImage'
import Spinner from 'react-bootstrap/Spinner'
import * as Yup from 'yup'
import { DevTool } from "react-hook-form-devtools";


function PixelSettingsSection({user, handleFormSubmission, isSaving}) {

    const { register, control, handleSubmit, setValue, getValues, formState, errors } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            facebookPixelId: Yup.string(),
        }),
        defaultValues: {
            facebookPixelId: user.instructorProfile?.facebookPixelId ?? "",
        }
    });

    const { dirty } = formState;

    const onSubmit = (data) => {

        if (handleFormSubmission) {
            var dataUpdate = {}
            dataUpdate['instructorProfile.facebookPixelId'] = data.facebookPixelId
            handleFormSubmission(dataUpdate)
        }
    }

    // useEffect(() => {
    //     register({ name: 'partnerLogo'})
    //     register({ name: 'primaryColor'})
    // }, [register])

    return (<>
        <form className="pixelInformationForm" onSubmit={handleSubmit(onSubmit)}>
            

            <section>


                <FormGroup
                fullSize
                type="text"
                name="facebookPixelId"
                label="Facebook Pixel ID"
                sublabel={(
                    <span><a href="https://www.facebook.com/business/help/952192354843755?id=1205376682832142" target="_blank">How to create and install pixel</a></span>
                )}
                placeholder=""
                register={register}
                error={errors.facebookPixelId}
                />

            </section>
            <section>
                <div className="row">
                    <div className="col-md-6">
                        {/* <button type="submit" className="btn btn-primary">Save changes</button> */}
                        <button disabled={!dirty} type="submit" className="btn btn-primary">
                        
                            <span>{"Save changes"}</span>

                            {isSaving && (
                                <Spinner
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden={true}
                                className="ml-2"
                                >
                                <span className="sr-only">Saving...</span>
                                </Spinner>
                            )}
                        </button>
                    </div>
                </div>
            </section>

        </form>
        <DevTool control={control} />
    </>)
}

export default PixelSettingsSection